import React from 'react';
import { connect } from 'react-redux';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import About from 'components/about';
import Contact from 'components/contact';
import Home from 'components/home';
import Training from 'components/training';

import {
    getMenuView,
    getToastContent,
    getToastOpen,
    getToastSeverity,
} from 'reducers/selectors';
import { setMenuView, closeToast } from 'actions/actions';

import { MENU_VIEWS } from 'util/constants';

import './app.scss';

const App = ({
    menuView,
    setMenuView,
    toastContent,
    toastOpen,
    toastSeverity,
    closeToast,
}) => (
    <div className="app">
        <header>
            <h1>Shane Randolph</h1>
            <h2>Experienced Full Stack Software Engineering Lead</h2>
        </header>
        <div>
            <Box
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                    maxHeight: '48px',
                }}
            >
                <Tabs
                    value={menuView}
                    onChange={(e, newValue) => setMenuView(newValue)}
                    sx={{ maxHeight: '30px', height: '30px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab
                        value={MENU_VIEWS.HOME}
                        label="Home"
                        sx={{ maxHeight: '30px', height: '30px' }}
                    />
                    <Tab
                        value={MENU_VIEWS.ABOUT}
                        label="Career"
                        sx={{ maxHeight: '30px', height: '30px' }}
                    />
                    <Tab
                        value={MENU_VIEWS.CONTACT}
                        label="Contact"
                        sx={{ maxHeight: '30px', height: '30px' }}
                    />
                    <Tab
                        value={MENU_VIEWS.TRAINING}
                        label="Life & Mind"
                        sx={{ maxHeight: '30px', height: '30px' }}
                    />
                </Tabs>
            </Box>
            <div
                className="bg-gradient-to-br from-indigo-50 via-white to-purple-50 p-4 rounded-xl shadow-sm p-6 border border-slate-200"
                style={{
                    width: '95%',
                    margin: '0 auto',
                    minHeight: 'calc(95dvh - 150px)',
                    height: 'calc(95dvh - 150px)',
                    overflowY: 'auto',
                    display: 'flex',
                    padding: '0px 10px 5px 10px',
                }}
            >
                <div className="spacer" />
                {menuView === MENU_VIEWS.HOME && <Home />}
                {menuView === MENU_VIEWS.ABOUT && <About />}
                {menuView === MENU_VIEWS.CONTACT && <Contact />}
                {menuView === MENU_VIEWS.TRAINING && <Training />}

                <div className="spacer" />
            </div>
        </div>

        <Snackbar
            open={toastOpen}
            autoHideDuration={4000}
            onClose={closeToast}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={closeToast}
                severity={toastSeverity}
                sx={{ width: '100%' }}
            >
                {toastContent}
            </Alert>
        </Snackbar>
    </div>
);

export default connect(
    state => {
        return {
            menuView: getMenuView(state),
            toastContent: getToastContent(state),
            toastOpen: getToastOpen(state),
            toastSeverity: getToastSeverity(state),
        };
    },
    {
        setMenuView,
        closeToast,
    }
)(App);
